// extracted by mini-css-extract-plugin
export default {"content":"AboutMuseum_content__hVNLw","contentWithImage":"AboutMuseum_contentWithImage__ijDXB","photoGallery":"AboutMuseum_photoGallery__nOeQz"};